import { render, staticRenderFns } from "./CourierReport.vue?vue&type=template&id=adb0f66e&"
import script from "./CourierReport.vue?vue&type=script&lang=js&"
export * from "./CourierReport.vue?vue&type=script&lang=js&"
import style0 from "./CourierReport.vue?vue&type=style&index=0&id=adb0f66e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports